import React from 'react';
import {
  Button,
} from 'react-bootstrap';

import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';

import EquipmentModalEnhanced from './EquipmentModalEnhanced';

import {
  defaultTableFiltering,
  tableStringSorting,
} from '../../../../utils';

const proptypes = exact({
  showEquipmentModal: PropTypes.bool.isRequired,
  equipmentList: PropTypes.array.isRequired,
  openEquipmentModal: PropTypes.func.isRequired,
});

const EquipmentTable = (props) => {
  const {
    equipmentList, openEquipmentModal, showEquipmentModal,
  } = props;
  return (
    <React.Fragment>
      <ReactTable
        data={equipmentList}
        filterable
        defaultFilterMethod={(filter, row) => {
          return defaultTableFiltering(filter, row);
        }}
        columns={[
          {
            Header: 'Equipment Number',
            id: 'equipment_number',
            accessor: (e) => { return e.equipment_number; },
          },
          {
            Header: 'Equipment Type',
            id: 'equipment_type',
            accessor: (e) => { return e.equipment_type; },
          },
          {
            Header: 'District',
            id: 'district',
            accessor: (e) => { return e.district; },
            sortMethod: (a, b) => {
              return tableStringSorting(a, b, 'name');
            },
            filterMethod: (filter, row) => {
              const customFilterObj = {
                id: 'name',
                value: filter.value,
              };
              return defaultTableFiltering(customFilterObj, row.district);
            },
            Cell: (row) => {
              return (
                <div>
                  { row.original.district.name }
                </div>
              );
            },
          },
          {
            Header: 'Department',
            id: 'department',
            accessor: (e) => { return e.department; },
            sortMethod: (a, b) => {
              return tableStringSorting(a, b, 'name');
            },
            filterMethod: (filter, row) => {
              const customFilterObj = {
                id: 'name',
                value: filter.value,
              };
              return defaultTableFiltering(customFilterObj, row.department);
            },
            Cell: (row) => {
              return (
                <div>
                  {row.original.department.name}
                </div>
              );
            },
          },
          {
            Header: 'Enabled',
            id: 'enabled',
            accessor: (e) => { return e.enabled; },
            Cell: (row) => {
              return (
                <div>
                  {(row.original.enabled).toString()}
                </div>
              );
            },
          },
          {
            Header: 'Notes',
            id: 'notes',
            accessor: (e) => { return e.notes; },
          },
          {
            Header: 'Actions',
            id: 'actions',
            filterable: false,
            sortable: false,
            Cell: (row) => {
              return (
                <div>
                  <Button
                    bsStyle="info"
                    onClick={() => { openEquipmentModal(row.original); }}
                  >Edit
                  </Button>
                </div>

              );
            },
          },
        ]}
        defaultPageSize={10}
        className="-striped -highlight"
      />
      { showEquipmentModal && <EquipmentModalEnhanced /> }
    </React.Fragment>
  );
};

EquipmentTable.propTypes = proptypes;
export default EquipmentTable;
